/** Minimal JWT payload decoding — no signature verification (that happens server-side). */
export interface JwtPayload {
  sub?: string;
  exp?: number;
  [claim: string]: unknown;
}

const base64UrlDecode = (segment: string): string => {
  const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  return decodeURIComponent(
    atob(padded)
      .split('')
      .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
      .join(''),
  );
};

export const decodeJwtPayload = (token: string): JwtPayload | null => {
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    return JSON.parse(base64UrlDecode(parts[1]));
  } catch {
    return null;
  }
};

export const isJwtExpired = (payload: JwtPayload): boolean =>
  typeof payload.exp === 'number' && payload.exp * 1000 < Date.now();
